




















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class GoodsFooter extends Vue {
  private gid: string | string[] = '';
  public created() {
    this.gid = this.$route.query.gid;
  }
  private buy() {
    console.log('buy: ', this.gid);
  }
  private fav() {
    console.log('fav: ', this.gid);
  }
  private cart() {
    console.log('cart: ', this.gid);
  }
}
